<template>
  <v-container class="fill-height align-start">
    <v-row no-gutters>
      <v-col cols="6">
        <ws-type-selector v-model="selectedFT" :set-global-filter="true" class="mr-2 fill-height"/>
      </v-col>
      <v-col cols="6">
        <wsStatusSelector v-model="selectedDS" :set-global-filter="true" class="mr-2 fill-height"/>
      </v-col>
      <v-col cols="12">
        <receptures-table v-model="currentRecepture" />
      </v-col>
      <v-col cols="12">
        <calculations-table v-model="currentCalculation" :conf="currentRecepture.length ? currentRecepture[0] : {}"/>
      </v-col>
    </v-row>
    <prj-action-dialog :project ="currentRecepture[0]" v-model="showChangeStatusDialog"></prj-action-dialog>
  </v-container>
</template>
<script>
import wsStatusSelector from '@/components/modules/projects/ui/wsStatusSelect.vue'
import WsTypeSelector from '@/components/modules/projects/ui/wsTypeSelector'
import RecepturesTable from '@/components/modules/projects/ui/tblRecepturesTable'
import { RCPT_SET_CURRENT } from '@/store/actions/receptures'

import {
  UI_ADD_ACTION,
  UI_DEL_ACTION,
  UI_SET_ACTIONS
  /*, UI_SNACKBAR */
} from '@/store/actions/ui'
import PrjActionDialog from '@/components/modules/projects/dialogs/prjActionDialog'
import { CALC_SET_CURRENT } from '@/store/actions/calculations'
import CalculationsTable from '@/components/modules/calcs/tables/tblCalculationsTable.vue'

export default {
  name: 'calcListView',
  components: {
    CalculationsTable,
    PrjActionDialog,
    WsTypeSelector,
    RecepturesTable,
    wsStatusSelector
  },
  data () {
    return {
      localFT: null,
      localDS: null,
      rcptAvlStatuses: [],
      showChangeStatusDialog: false,
      addAction: { text: 'Новый расчёт', actionType: 'Расчёты', action: 'addNewConfig', method: this.addCalc, icon: 'mdi-plus', params: '' },
      viewAction: { text: 'Просмотр', actionType: 'Расчёты', action: 'viewConfig', method: this.viewCalc, icon: 'mdi-magnify', params: '' },
      postAction: { text: 'Изменить статус', actionType: 'Конфигурация', action: 'postConfig', method: this.postConfig, icon: 'mdi-cube-send', params: '' }
    }
  },
  computed: {
    selectedFT: {
      get: function () {
        return this.$store.getters.getCurrentRecepturesTypeFilter
      },
      set: function (val) {
        this.localFT = val
      }
    },
    selectedDS: {
      get: function () {
        return this.$store.getters.getCurrentRecepturesStateFilter
      },
      set: function (val) {
        this.localDS = val
      }
    },
    currentRecepture: {
      get: function () {
        const ret = this.$store.getters.getCurrentRecepture.ULF_UUID ? [this.$store.getters.getCurrentRecepture] : []
        console.log('myCalculations: getting current recepture ', ret)
        return ret
      },
      set: function (val) {
        console.log('myCalculations: setting current recepture ', val)
        this.$store.dispatch(RCPT_SET_CURRENT, val.length > 0 ? val[0] : {})
      }
    },
    currentCalculation: {
      get: function () {
        const ret = this.$store.getters.getCurrentCalculation.CALC_UUID ? [this.$store.getters.getCurrentCalculation] : []
        console.log('myCalculations: getting current calculation ', ret)
        return ret
      },
      set: function (val) {
        console.log('myCalculations: setting current calculation ', val)
        this.$store.dispatch(CALC_SET_CURRENT, val.length > 0 ? val[0] : {})
      }
    }
  },
  mounted: function () {
    console.log('views::myCalculations index mounted')
    this.setActions()
  },
  watch: {
    currentRecepture () {
      this.setActions()
    },
    currentCalculation () {
      this.setActions()
    }
  },
  methods: {
    setActions () {
      console.log('myCalculations setting actions')
      this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Расчёты', actions: [] })
      this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Конфигурация', actions: [] })
      if (!this.currentRecepture.length) { return }
      if (this.currentRecepture[0].ULF_UUID) {
        this.$store.dispatch(UI_ADD_ACTION, this.postAction)
        this.$store.dispatch(UI_ADD_ACTION, this.addAction)
      } else {
        this.$store.dispatch(UI_DEL_ACTION, this.postAction)
        this.$store.dispatch(UI_DEL_ACTION, this.addAction)
      }
      if (this.currentCalculation.length && this.currentCalculation[0].CALC_UUID) {
        this.$store.dispatch(UI_ADD_ACTION, this.viewAction)
      } else {
        this.$store.dispatch(UI_DEL_ACTION, this.viewAction)
      }
    },
    addCalc () {
      console.log('Trying to add calculation')
      this.$store.dispatch(RCPT_SET_CURRENT, this.currentRecepture[0])
      this.$router.push({ path: '/projects/calc' })
    },
    postConfig () {
      console.log('Trying to change recepture state')
      this.showChangeStatusDialog = true
    },
    viewCalc () {
      console.log('Trying to view calculation', this.currentCalculation[0])
      this.$router.push({ path: '/projects/calc' })
    }
  }
}
</script>
